import React from 'react';
import PropTypes from 'prop-types';
import twemoji from 'twemoji';

const Twemoji = ({className, emoji}) => (
  <span
    className={className}
    dangerouslySetInnerHTML={{__html: twemoji.parse(emoji)}} // eslint-disable-line
  />
);

Twemoji.propTypes = {
  className: PropTypes.string,
  emoji: PropTypes.string.isRequired,
};

Twemoji.defaultProps = {
  className: '',
};

export default Twemoji;
